import { AvatarGroup, Box, Skeleton, Stack, Tooltip } from '@mui/material';
import { AugmentedBlueticksBoardUser, cellPersonListSelector } from '@common-reducers/BoardsSelectors';
import { useAppSelector } from "@common-reducers/hooks/store.hook";
import { FaUserCircle } from 'react-icons/fa';
import { CellProps } from '../cell-interface';
import { isTempId } from "@common-reducers/DBServiceThunks";
import { PersonAvatar } from '@common-components/tasks/person-avatar/person-avatar';
import { userDisplayName } from '@common-models/user';

export type PersonPickerIDType = 'user' | 'option';

export interface PersonPickerValue {
  id: string;
  type: PersonPickerIDType;
}

export default function PersonPickerCell({
  taskId,
  cellValue,
  columnId,
  mockValue,
  togglePicker,
  boardId
}: CellProps<PersonPickerValue[]>) {
  const anchorId = `person_${taskId}_${columnId}`;
  const personList: AugmentedBlueticksBoardUser[] = useAppSelector(state => cellPersonListSelector(state, cellValue ?? [], boardId));
  const cellPersonList: AugmentedBlueticksBoardUser[] = personList?.length > 0 ? personList : [];

  const extraFilesTheme = {
    alignItems: "end",
    ".MuiAvatar-circular": {
      height: '20px',
      width: '20px',
      background: 'var(--color-primary)',
      color: 'white',
      fontSize: '10px',
    }
  }

  const personSize = 22;

  return (
    isTempId(columnId ?? null) ?
      (<Skeleton variant="rectangular" />)
      :
      <Stack direction={'row'} alignItems={'center'} id={anchorId}
        onClick={() => togglePicker({
          anchorId: anchorId,
          pickerType: 'person-picker',
        })}
        sx={{
          cursor: 'pointer',
          width: '100%',
          justifyContent: 'center',
          padding: !mockValue ? "0 5px" : undefined
        }}
      >
        <Tooltip title={
          <Stack direction={'column'}>
            {cellPersonList.map((person: AugmentedBlueticksBoardUser, i: number) => <Box dir='auto' key={person?._id ?? i}>{userDisplayName(person?.profile)}</Box>)}
          </Stack>
        }>
          <AvatarGroup sx={extraFilesTheme} max={3}>
            {cellPersonList.map((person: AugmentedBlueticksBoardUser, i: number) => {
              const profile = person?.profile ?? undefined;
              return (
                <Box key={person?._id ?? i}>
                  <PersonAvatar
                    size={personSize}
                    email={profile?.email}
                    profileImg={profile?.profileImg}
                    lastName={(profile?.lastName === 'undefined' || profile?.lastName === undefined) ? ' ' : profile?.lastName}
                    firstName={profile?.firstName} />
                </Box>
              )
            })
            }
          </AvatarGroup>
        </Tooltip>
        {cellPersonList.length === 0 &&
          <FaUserCircle color="#809ba8" size={personSize} />
        }
      </Stack>
  )
}